import {
	unarchiveDealDraftMips,
	deleteDealMipsAndInvestors,
} from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { logger } from '@dealstack/frontend/shared/mechanism/logger/logger';
import { useDSToast } from '@dealstack/frontend/shared/mechanism/toast/useDSToast';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useState } from 'react';

export const useDealArchiveButton = (
	dealId: string,
	isDealArchived: boolean,
	refetchDealData: () => void
) => {
	const toastAPI = useDSToast();

	const [showArchiveDealConfirmationModal, setShowArchiveDealConfirmationModal] = useState(false);

	const updateDealDeletedRequest = useMutation({
		mutationFn: unarchiveDealDraftMips,
	});
	const updateDealMipsInvestorsDeletedRequest = useMutation({
		mutationFn: deleteDealMipsAndInvestors,
	});

	const archiveWholeDeal = () => {
		updateDealMipsInvestorsDeletedRequest.mutate(
			{
				dealId,
			},
			{
				onError: (error) => {
					logger.error(error);
					toastAPI.error({
						message: "Data couldn't be updated!",
					});
				},
				onSuccess: () => {
					refetchDealData();
					toastAPI.success({
						message: 'Successfully updated!',
					});
				},
			}
		);
	};

	const unarchiveDeal = () => {
		updateDealDeletedRequest.mutate(
			{
				dealId,
			},
			{
				onError: (error) => {
					logger.error(error);
					toastAPI.error({
						message: "Data couldn't be updated!",
					});
				},
				onSuccess: () => {
					refetchDealData();
					toastAPI.success({
						message: 'Successfully updated!',
					});
				},
			}
		);
	};
	const onSubmit = useCallback(() => {
		if (isDealArchived) {
			unarchiveDeal();
		}
		if (!isDealArchived) {
			archiveWholeDeal();
		}
		setShowArchiveDealConfirmationModal(false);
	}, [isDealArchived]);

	return {
		showArchiveDealConfirmationModal,
		setShowArchiveDealConfirmationModal,
		onSubmit,
	};
};
